import styled from 'styled-components';

export * from './common.style';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 5.6rem;
  padding: ${({ theme }) => `0 ${theme.spacing(4)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const HeaderButtons = styled.div``;
